export default __webpack_public_path__ + "static/media/bd-exec-4.46b1ae47.jpg";